import React from "react";

export default function Sms_Notification() {
  return <div>SMS Notification</div>;
}
